import { useAuth } from 'src/auth/AuthContext';
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "../pages/login";
import ForgotPassword from "../pages/forgotPassword";
import MerchantPage from "../pages/merchantInfo";
import TOS from "../pages/tos/tos";
import ProtectedRoute from "../components/Routes/ProtectedRoute";
import MainLayout from "../components/MainLayout";
import CreateLocationPage from "../pages/createLocation";
import UserPage from "../pages/user/user";
import SubscriptionPage from "../pages/subscription";
import ManageTeamPage from "src/pages/manageTeam";
import LocationRoute from "src/components/Routes/LocationRoute";
import SuperAdminRoute from "src/components/Routes/SuperAdminRoute";
import DigitalFlyersPage from "src/pages/digitalFlyers";
import LocationsPage from "src/pages/locations";
import AnalyticsPage from "src/pages/analytics";
import FlyerAdminPage from "src/pages/admin/flyers";
import SubscriptionAdminPage from "src/pages/admin/subscriptions";
import StatsAdminPage from "src/pages/admin/stats";
import UninvoicedPaymentsPage from "src/pages/admin/uninvoiced-payments";

const RouterConfig: React.FC = () => {
  const loggedIn = useAuth().loggedIn;

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={<Navigate to={loggedIn ? "/locations" : "/login"} />}
        />
        <Route path="/login" element={<Login />} />
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/tos" element={<TOS />} />

        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/locations" element={<LocationsPage />} />
            <Route path="/locations/:id" element={<LocationRoute />}>
              <Route index element={<MerchantPage />} />
              <Route path="analytics" element={<AnalyticsPage />} />
              <Route path="team" element={<ManageTeamPage />} />
              <Route path="subscription" element={<SubscriptionPage />} />
              <Route path="digital-flyers" element={<DigitalFlyersPage />} />
            </Route>
            <Route path="/user" element={<UserPage />} />
            <Route path="/create-location" element={<CreateLocationPage />} />

            {/* Super Admin Routes */}
            <Route element={<SuperAdminRoute />}>
              <Route path="/admin/flyers" element={<FlyerAdminPage />} />
              <Route path="/admin/subscriptions" element={<SubscriptionAdminPage />} />
              <Route path="/admin/stats" element={<StatsAdminPage />} />
              <Route path="/admin/uninvoiced-payments" element={<UninvoicedPaymentsPage />} />
            </Route>

            {/* Legacy paths from the pre-/locations navigation */}
            <Route path="/home" element={<Navigate to="/locations" replace />} />
            <Route path="/merchant" element={<Navigate to="/locations" replace />} />
            <Route path="/merchant/team" element={<Navigate to="/locations" replace />} />
            <Route path="/subscription" element={<Navigate to="/locations" replace />} />
            <Route path="/digital-flyers" element={<Navigate to="/locations" replace />} />
            <Route path="/create-merchant" element={<Navigate to="/create-location" replace />} />
          </Route>
        </Route>

      </Routes>
    </Router>
  );
};

export default RouterConfig;
